{
  "dashboard": "Dashboard",
  "masters": "Masters",
  "transactions": "Transactions",
  "purchaseRequest": "Purchase Requests",
  "purchaseOrder": "Purchase Orders",
  "gateEntry": "Gate Entries",
  "grn": "Goods Receipt Note",
  "qc": "Quality Control",
  "putaway": "Putaway",
  "warehouseTransferReceipt": "Warehouse Transfer Receipt",
  "materialRequest": "Material Request",
  "productionOrders": "Production Plan",
  "jobWorkOrders": "Job Work Order",
  "jobWorkIssue": "Job Work Issue",
  "jobWorkReceipt": "Job Work Receipt",
  "jobWorkQc": "Job Work QC",
  "jobWorkLabelPrint": "Job Work Label Print",
  "jobWorkPutaway": "Job Work Putaway",
  "weightProductionPlan": "Production Plan",
  "weightProductionIssue": "Material Issue",
  "weightProductionKiosk": "Weighing Kiosk",
  "weightProductionJobCompletion": "Job Completion",
  "weightProductionPutaway": "FG Putaway",
  "weightProductionLabelPrint": "Label Reprint",
  "hardwareConfiguration": "Weighing Stations",
  "hardwareMonitor": "Hardware Monitor",
  "productionPickList": "Production Pick List",
  "materialIssue": "Material Issue",
  "productionReceipt": "Production Receipt",
  "productionLabelPrint": "Production Label Print",
  "productionPutaway": "Production Putaway",
  "picking": "Picking",
  "dispatchOrder": "Dispatch Order",
  "dispatchPickList": "Dispatch Pick List",
  "dispatchMaterialIssue": "Dispatch Material Issue",
  "packing": "Packing",
  "packingLabelPrint": "Packing Label Print",
  "loading": "Loading",
  "gateExit": "Gate Exit",
  "stockAdjustment": "Stock Adjustment",
  "stockTransfer": "Stock Transfer",
  "cycleCount": "Cycle Count",
  "returnNote": "Returns",
  "billing": "Billing",
  "reportsInventory": "Inventory Reports",
  "reportsTraceability": "Traceability Report",
  "reportsProcurement": "Procurement Reports",
  "reportsInboundQuality": "Inbound & Quality Reports",
  "reportsOutbound": "Outbound Reports",
  "reportsProduction": "Production Reports",
  "reportsAdjustments": "Adjustments Reports",
  "reportsApprovals": "Approvals Reports",
  "reportsClientSummary": "3PL Client Summary",
  "labelDesigner": "Label Designer",
  "labelPrinting": "GRN Label Print",
  "administration": "Administration",
  "companies": "Companies",
  "activityLog": "Activity Log",
  "users": "User Management & Roles",
  "approvalMatrix": "Approval Matrix",
  "processConfiguration": "Process Configuration",
  "helpAndSupport": "Help",
  "lightMode": "Switch to light mode",
  "darkMode": "Switch to dark mode",
  "openTvDisplay": "Open TV Display",
  "myProfile": "My Profile",
  "logout": "Logout",
  "groups": {
    "procurement": "Procurement",
    "inboundQuality": "Inbound & Quality",
    "production": "Production",
    "jobWork": "Job Work",
    "weightProduction": "Weigh & Label",
    "outbound": "Outbound",
    "adjustments": "Adjustments",
    "billing": "Billing",
    "reports": "Reports",
    "tools": "Tools",
    "administration": "Administration"
  },
  "expandSidebar": "Expand sidebar",
  "collapseSidebar": "Collapse sidebar",
  "openSidebar": "Open navigation menu",
  "notifications": "Notifications",
  "pendingApprovals": "Pending Approvals",
  "noNotifications": "You're all caught up — nothing pending.",
  "approve": "Approve",
  "reject": "Reject",
  "markAllRead": "Mark all read",
  "networkOffline": "Offline",
  "networkOnline": "Online",
  "networkPoor": "Poor connection",
  "networkFair": "Fair connection",
  "networkGood": "Good connection",
  "networkExcellent": "Excellent connection",
  "reportsJobWork": "Job Work Reports",
  "reportsWeightProduction": "Weigh & Label Reports"
}
